import { createElement } from 'react';

import { cn } from '@/lib/utils/tailwind';

import { textVariants } from './variants';

import type { TextProps } from './types';

export const Text = ({
  variant = 'body',
  weight,
  as = 'p',
  children,
  className,
  size,
  ref,
  ...props
}: TextProps) => {
  return createElement(
    as,
    {
      className: cn(textVariants({ variant, size, weight }), className),
      ref,
      ...props,
    },
    children,
  );
};
